import { HomeProduct, ProductRelated } from '~/src/common/typings/product';
import { ATCSource, ATCSourceFrom } from '~/src/screens/CatalogContent/ContentScreen/types';

/*
    Type pour <ProductCard/>
    <ProductCard> peut recevoir un produit de la Home et un produit issu du cross sell
*/
export type BasicProduct = HomeProduct | ProductRelated;

const productCardSourceTypes = [
  'products list',
  'similar cross sell',
  'complementary cross sell',
  'search results',
  'checkout cross sell',
  'lastminute cross sell',
  'search cross sell',
  'my products',
] as const;

// Regroupe toutes les sources possibles pour une carte produit
export type ProductCardSource =
  | Extract<ATCSource, { type: (typeof productCardSourceTypes)[number] }>
  | { type: 'my products' };

export const isProductCardSource = (
  value: ATCSource | ATCSourceFrom,
): value is ProductCardSource => {
  return productCardSourceTypes.includes(value.type as (typeof productCardSourceTypes)[number]);
};

const recipeCardSourceTypes = [
  'products list',
  'recipe page cross sell',
  'recipes list',
  'search results',
] as const;

// Regroupe toutes les sources possibles pour une carte recette
export type RecipeCardSource = Extract<
  ATCSource | ATCSourceFrom,
  { type: (typeof recipeCardSourceTypes)[number] }
>;

export const isRecipeCardSource = (value: ATCSource | ATCSourceFrom): value is RecipeCardSource => {
  return recipeCardSourceTypes.includes(value.type as (typeof recipeCardSourceTypes)[number]);
};
